import * as React from "react";
import ImageTextCtaSlider, {
    ImageTextCtaSliderProps
} from "~/components/image-text-cta-slider/image-text-cta-slider";

export interface IImageTextCtaSliderViewProps {
    contextModel: ImageTextCtaSliderProps;
}

class ImageTextCtaSliderView extends React.PureComponent<IImageTextCtaSliderViewProps> {
    public render() {
        return <ImageTextCtaSlider {...this.props.contextModel} />;
    }
}

export default ImageTextCtaSliderView;
